import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    width:"100%",
    margin:"24px 0px",
    borderTop:"2px dotted #dcdcdc"
  }
}));
const DottedDivider = (props) => {
    const classes = useStyles();
  return (
    <div className={classes.root}>

    </div>
  );
}
export default DottedDivider;